/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LandingPageDataResponse,
  PublicControllerGetUnitsParams,
  PublicExportRequest,
  PublicUnitResponse,
  PublicUnitResponseItem,
  SimpleUserResponse
} from './sAFcBackend.schemas.js';

import publicControllerGetMeMutator from '../response-type.js';
import publicControllerGetUnitsMutator from '../response-type.js';
import publicControllerGetLandingPageStatsMutator from '../response-type.js';
import publicControllerGetUnitByIdMutator from '../response-type.js';
import publicControllerExportMutator from '../response-type.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const publicControllerGetMe = (

 options?: SecondParameter<typeof publicControllerGetMeMutator>,signal?: AbortSignal
) => {


      return publicControllerGetMeMutator<SimpleUserResponse>(
      {url: `/api/public/maybe-me`, method: 'GET', signal
    },
      options);
    }




export const getPublicControllerGetMeQueryKey = () => {
    return [
    `/api/public/maybe-me`
    ] as const;
    }


export const getPublicControllerGetMeQueryOptions = <TData = Awaited<ReturnType<typeof publicControllerGetMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetMeMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicControllerGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicControllerGetMe>>> = ({ signal }) => publicControllerGetMe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicControllerGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof publicControllerGetMe>>>
export type PublicControllerGetMeQueryError = unknown


export function usePublicControllerGetMe<TData = Awaited<ReturnType<typeof publicControllerGetMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetMeMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetMe<TData = Awaited<ReturnType<typeof publicControllerGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetMeMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetMe<TData = Awaited<ReturnType<typeof publicControllerGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetMeMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicControllerGetMe<TData = Awaited<ReturnType<typeof publicControllerGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetMeMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicControllerGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const publicControllerGetUnits = (
    params: PublicControllerGetUnitsParams,
 options?: SecondParameter<typeof publicControllerGetUnitsMutator>,signal?: AbortSignal
) => {


      return publicControllerGetUnitsMutator<PublicUnitResponse>(
      {url: `/api/public/units`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPublicControllerGetUnitsQueryKey = (params?: PublicControllerGetUnitsParams,) => {
    return [
    `/api/public/units`, ...(params ? [params] : [])
    ] as const;
    }


export const getPublicControllerGetUnitsQueryOptions = <TData = Awaited<ReturnType<typeof publicControllerGetUnits>>, TError = unknown>(params: PublicControllerGetUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnits>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetUnitsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicControllerGetUnitsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicControllerGetUnits>>> = ({ signal }) => publicControllerGetUnits(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicControllerGetUnitsQueryResult = NonNullable<Awaited<ReturnType<typeof publicControllerGetUnits>>>
export type PublicControllerGetUnitsQueryError = unknown


export function usePublicControllerGetUnits<TData = Awaited<ReturnType<typeof publicControllerGetUnits>>, TError = unknown>(
 params: PublicControllerGetUnitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetUnits>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetUnitsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetUnits<TData = Awaited<ReturnType<typeof publicControllerGetUnits>>, TError = unknown>(
 params: PublicControllerGetUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetUnits>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetUnitsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetUnits<TData = Awaited<ReturnType<typeof publicControllerGetUnits>>, TError = unknown>(
 params: PublicControllerGetUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnits>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetUnitsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicControllerGetUnits<TData = Awaited<ReturnType<typeof publicControllerGetUnits>>, TError = unknown>(
 params: PublicControllerGetUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnits>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetUnitsMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicControllerGetUnitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const publicControllerGetLandingPageStats = (

 options?: SecondParameter<typeof publicControllerGetLandingPageStatsMutator>,signal?: AbortSignal
) => {


      return publicControllerGetLandingPageStatsMutator<LandingPageDataResponse>(
      {url: `/api/public/landing-page`, method: 'GET', signal
    },
      options);
    }




export const getPublicControllerGetLandingPageStatsQueryKey = () => {
    return [
    `/api/public/landing-page`
    ] as const;
    }


export const getPublicControllerGetLandingPageStatsQueryOptions = <TData = Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetLandingPageStatsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicControllerGetLandingPageStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>> = ({ signal }) => publicControllerGetLandingPageStats(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicControllerGetLandingPageStatsQueryResult = NonNullable<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>>
export type PublicControllerGetLandingPageStatsQueryError = unknown


export function usePublicControllerGetLandingPageStats<TData = Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetLandingPageStatsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetLandingPageStats<TData = Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetLandingPageStatsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetLandingPageStats<TData = Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetLandingPageStatsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicControllerGetLandingPageStats<TData = Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetLandingPageStats>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetLandingPageStatsMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicControllerGetLandingPageStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const publicControllerGetUnitById = (
    id: string,
 options?: SecondParameter<typeof publicControllerGetUnitByIdMutator>,signal?: AbortSignal
) => {


      return publicControllerGetUnitByIdMutator<PublicUnitResponseItem>(
      {url: `/api/public/unit/${id}`, method: 'GET', signal
    },
      options);
    }




export const getPublicControllerGetUnitByIdQueryKey = (id: string,) => {
    return [
    `/api/public/unit/${id}`
    ] as const;
    }


export const getPublicControllerGetUnitByIdQueryOptions = <TData = Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetUnitByIdMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicControllerGetUnitByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicControllerGetUnitById>>> = ({ signal }) => publicControllerGetUnitById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicControllerGetUnitByIdQueryResult = NonNullable<Awaited<ReturnType<typeof publicControllerGetUnitById>>>
export type PublicControllerGetUnitByIdQueryError = unknown


export function usePublicControllerGetUnitById<TData = Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetUnitById>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetUnitById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetUnitByIdMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetUnitById<TData = Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicControllerGetUnitById>>,
          TError,
          Awaited<ReturnType<typeof publicControllerGetUnitById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicControllerGetUnitByIdMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicControllerGetUnitById<TData = Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetUnitByIdMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicControllerGetUnitById<TData = Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicControllerGetUnitById>>, TError, TData>>, request?: SecondParameter<typeof publicControllerGetUnitByIdMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicControllerGetUnitByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Export publicly available units table
 */
export const publicControllerExport = (
    publicExportRequest: PublicExportRequest,
 options?: SecondParameter<typeof publicControllerExportMutator>,signal?: AbortSignal
) => {


      return publicControllerExportMutator<Blob>(
      {url: `/api/public/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: publicExportRequest,
        responseType: 'blob', signal
    },
      options);
    }




export const getPublicControllerExportMutationKey = () => ['publicControllerExport'] as const;

export const getPublicControllerExportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicControllerExport>>, TError,PublicControllerExportMutationVariables, TContext>, request?: SecondParameter<typeof publicControllerExportMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof publicControllerExport>>, TError,PublicControllerExportMutationVariables, TContext> => {

const mutationKey = getPublicControllerExportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicControllerExport>>, PublicControllerExportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  publicControllerExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublicControllerExportMutationResult = NonNullable<Awaited<ReturnType<typeof publicControllerExport>>>
    export type PublicControllerExportMutationBody = PublicExportRequest
    export type PublicControllerExportMutationError = unknown
    export type PublicControllerExportMutationVariables = {data: PublicExportRequest}

    export const usePublicControllerExport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicControllerExport>>, TError,PublicControllerExportMutationVariables, TContext>, request?: SecondParameter<typeof publicControllerExportMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publicControllerExport>>,
        TError,
        PublicControllerExportMutationVariables,
        TContext
      > => {
      return useMutation(getPublicControllerExportMutationOptions(options), queryClient);
    }
